import { OEPanelBaseModel } from "./oe-panel-base.model";
import { BfxAutocompleteGenericModel } from "app/bfx-interface-controls/models/bfx-interface-controls.models";
// multi-asset
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import {
  ICAutocompleteGenericModel,
  ICTenorValueDateModel,
} from "../../interface/controls/models/bfx-interface-controls.models";
import { ICNInputControlState } from "../../interface/controls/models/bfx-interface-controls.enums";
import { OENLockedState } from "../enums/oe-locked-state.enum";
import {
  BenchmarkFixingDetail,
  BenchmarkFixingTime,
} from "shared/cubiq-services/lookup/model/impl/BenchmarkFixingPrimaryLookupService";

export class OEPanelBmarkModel extends OEPanelBaseModel {
  public readonly orderType: any = {
    value: null,
    disabled: true,
    dataset: null,
    lockState: OENLockedState.LOCKED,
  };

  public trigger: any = {
    label: "Trigger",
    value: null,
    dataset: [],
    spotTrigger: new ICAutocompleteGenericModel(CubiqTS.RequestTrackingType.SPOT_RATE, "Spot"),
    outrightTrigger: new ICAutocompleteGenericModel(
      CubiqTS.RequestTrackingType.OUTRIGHT_RATE,
      "Outright",
    ),
    disabled: false,
    externalState: null,
    state: ICNInputControlState.INACTIVE,
    lockState: OENLockedState.UNLOCKED,
    locked: false,
  };

  public fixing = OEPanelBmarkModel.defaultFixing;
  public unmatchedFixingDetails: BenchmarkFixingTime = null;

  public static get defaultFixing() {
    return {
      locked: true,
      allBmarkFixings: [],
      allBmarkCodes: [],
      lockState: OENLockedState.LOCKED,

      codeDisabled: false,
      disabled: true,

      fixingCodeLabel: "Fixing Code",
      fixingCodes: [],
      fixingCode: null,
      fixingCodeState: ICNInputControlState.INACTIVE, // state of fixing code

      fixingLabel: "Fixing Time",
      fixings: [],
      fixing: null,
      fixingState: ICNInputControlState.INACTIVE, // state of fixing time

      zeroAvailableFixings: false,
    };
  }

  public fixingDate = OEPanelBmarkModel.defaultFixingDate;
  public static get defaultFixingDate() {
    const now = CubiqTS.moment();

    return {
      label: "Fixing Date",
      labelKey: "order_entry.panel.label.fixing_date",
      value: now.toDate(),
      isEntrAllowed: true,
      disabled: true,
      externalState: null,
      minDate: now.subtract(1, "days").toDate(),
      state: ICNInputControlState.INACTIVE,
      lockState: OENLockedState.UNLOCKED,
      locked: false,
    };
  }

  public valueDate: {
    label: string;
    labelKey: string;
    value: ICTenorValueDateModel | null;
    isSpot: boolean;
    isBrokenDate: boolean;
    dataset: CubiqTS.CurrencyPairCalendarImpl;
    disabled: boolean;
    externalState: ICNInputControlState;
    state: ICNInputControlState;
    lockState: OENLockedState;
  } = {
    label: "Value date",
    labelKey: "order_entry.panel.label.value_date",
    value: new ICTenorValueDateModel(CubiqTS.Tenor.SPOT, null), // ICTenorValueDateModel
    isSpot: true,
    isBrokenDate: false,
    dataset: null, // CurrencyPairCalendarImpl
    disabled: true,
    externalState: null,
    state: ICNInputControlState.INACTIVE,
    lockState: OENLockedState.UNLOCKED,
  };

  public allocations: {
    show: boolean;
    value: Array<any>;
    locked: boolean;
  } = {
    show: true,
    value: null,
    locked: false,
  };

  public farAllocations: {
    value: Array<any>;
  } = {
    value: null,
  };

  public product: {
    value: CubiqTS.Product;
  } = {
    value: null,
  };

  public swapFixedAmount: {
    value: CubiqTS.BigNumber;
  } = {
    value: null,
  };

  public swapTenor: {
    value: CubiqTS.Tenor;
  } = {
    value: null,
  };

  public swapValueDate: {
    value: CubiqTS.StandardDate;
  } = {
    value: null,
  };
}
